import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { getApi } from "../../utils/api";
import {
  API_V2_APPROVER_ASSEST_REQUEST_LIST,
  GET_ASSET_REQUEST_EMP_NAMES,
  ASSET_LIST,
} from "../../config/Endpoints";
import { ThreeDots } from "react-loader-spinner";
import { formatDate, toggleMenu } from "../../utils/helpers";
import Footer from "../../components/Footer";
import AssetRequestApproveForm from "./AssetRequestApproveForm";
import PageTitle from "../../components/PageTitle";
import SortableTable from "../../components/SortableTable";
import Pagination from "../../components/Pagination";
import Select from "react-select";

const ApproveAssetRequestL2 = ({ title, description }) => {
  const [assetId, setAssetId] = useState("");
  const [assetList, setAssetList] = useState([]);
  const [requestAsset, setRequestAsset] = useState([]);
  const [assetStatusList, setAssetStatusList] = useState([]);
  const [selectedAssetRequest, setSelectedAssetRequest] = useState({});
  const [filteredItems, setFilteredItems] = useState([]);
  const [assetAvailability, setAssetAvailability] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = Cookies.get("accessToken");
  const [selectedEmployeeId, setSelectedEmployeeId] = useState("");
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const columns = [
    { key: "assetType", label: "Asset Type" },
    { key: "employeeName", label: "Employee Name" },
    { key: "reason", label: "Reason" },
    {
      key: "requestedDate",
      label: "Requested Date",
      compare: (a, b) =>
        new Date(a._original.requestDate) - new Date(b._original.requestDate),
    },
    {
      key: "action",
      label: "Action",
      sortable: false,
      render: (item) => {
        return requestAsset?.approver ? (
          <a
            data-bs-toggle="modal"
            data-bs-target="#staticBackdropAssetRequest"
            onClick={() => {
              // handleAsset(item.assestRequestId);
              setAssetId(item._original.assestRequestId);
              setSelectedAssetRequest(item._original);
            }}
          >
            View
          </a>
        ) : (
          "-"
        );
      },
    },
  ];
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(
      filteredItems.map((item) => ({
        assetType: item.assestType,
        employeeName: item.employeeName,
        reason: item.reason,
        requestedDate: formatDate(item.requestDate),
        _original: item,
      })) || []
    );
  }, [filteredItems]);

  useEffect(() => {
    fetchData();
  }, [currentPage, limit, selectedEmployeeId]);

  const fetchData = () => {
    setIsLoading(true);
    const employeeParam = selectedEmployeeId ? `id=${selectedEmployeeId}&` : "";
    getApi(
      API_V2_APPROVER_ASSEST_REQUEST_LIST +
        `?${employeeParam}page=${currentPage - 1}&size=${limit}&level=L2`,
      accessToken
    )
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setAssetList(res.data.data);
          setFilteredItems(res.data.data);
          setRequestAsset(res.data);
          setAssetStatusList(res.data.status);
          setTotalPages(res.data.totalPages);
        }
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setCurrentPage(1);
  };

  const fetchEmployeeNames = async () => {
    try {
      const res = await getApi(`${GET_ASSET_REQUEST_EMP_NAMES}?level=L2`, accessToken);
      if (res.status === 200) {
        setEmployeeOptions(
          res.data.data.map((emp) => ({
            value: emp.id,
            label: emp.name,
          }))
        );
      }
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    fetchEmployeeNames();
  }, []);

  const handleAsset = async (id) => {
    // Get asset list regardless of whether the asset type is the same or different
    setAssetAvailability("");
    await getApi(ASSET_LIST + `?assestTypeId=${id}`, accessToken)
      .then((res) => {
        if (res.status === 200) {
          setAssetAvailability(res?.data?.data?.length);
        }
      })
      .catch((e) => {
        console.log(e);
        // setIsAssetLoading(false);
      });
  };

  return (
    <div className="wrapper-body">
      {/* Page Heading */}
      <div className="page-heading">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <PageTitle title={title} description={description} />
        <div className="total">
          Total Asset Requested: <span>{filteredItems?.length}</span>
        </div>
      </div>
      {/* Filters */}
      <div className="filters">
        {/* <form action="index.html" id="form_filters" className="d-f"> */}
        {/* Search By Company */}

        <div className="col-md-5">
          <label className="label">Select Employee Name</label>

          <Select
            options={[...employeeOptions]}
            value={
              employeeOptions.find((opt) => opt.value === selectedEmployeeId) ||
              null
            }
            onChange={(selected) => {
              setSelectedEmployeeId(selected ? selected.value : null);
              setCurrentPage(1);
            }}
            isClearable
            placeholder="All"
          />
        </div>

        {/* <button type="submit" form="form_filters">
          Search
        </button> */}
        {/* </form> */}

        {/* Actions */}
        <div className="actions">
          {/* <Link
            to="/dashboard/createAssetRequest"
            className="export theme-button"
          >
            Asset Request
          </Link> */}
        </div>
      </div>
      {isLoading && (
        <div className="centered-loader">
          <ThreeDots
            height="100"
            width="100"
            radius="9"
            color="blue"
            ariaLabel="three-dots-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}
      {/* Data Table */}
      {!isLoading && filteredItems?.length > 0 && (
        <>
          <SortableTable
            columns={columns}
            data={tableData}
            currentPage={currentPage}
            limit={limit}
          />
          <div className="row">
            <div className="col-md-3">
              <div>
                {/* Dropdown for selecting items per page */}
                <label htmlFor="itemsPerPage">Items per page </label>
                <select
                  id="itemsPerPage"
                  onChange={handleLimitChange}
                  value={limit}
                  className="border ms-3 w-25  p-2"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={30}>30</option>
                  <option value={40}>40</option>
                </select>
              </div>
            </div>
            <div className="col-md-9">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
              />
            </div>
          </div>
        </>
      )}
      {!isLoading && filteredItems?.length === 0 && (
        <div className="fs-4 text-secondary text-center">
          <h4>No Record Available</h4>
        </div>
      )}{" "}
      <div
        className="modal fade  bd-example-modal-lg"
        id="staticBackdropAssetRequest"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <AssetRequestApproveForm
              assetId={assetId}
              header="Approve Asset Request (L2) Action"
              prevLevelCommentLabel="Asset L1 Comment"
              selectedAssetRequest={selectedAssetRequest}
              assetStatusList={assetStatusList}
              fetchData={fetchData}
              assetAvailability={assetAvailability}
            />
          </div>
        </div>
      </div>
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ApproveAssetRequestL2;
